import { render, staticRenderFns } from "./DigiBoardLicenceCounts.vue?vue&type=template&id=a75acb2e"
import script from "./DigiBoardLicenceCounts.vue?vue&type=script&lang=js"
export * from "./DigiBoardLicenceCounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports